import React from 'react';

import PropTypes from 'prop-types';

// Components
import { Mui } from 'components';
import PercentageField from 'components/common/DisplayData/PercentageField';

const useStyles = Mui.makeStyles(() => ({
  variation: {
    display: 'flex',
  },
  value: {
    alignItems: 'center',
    display: 'flex',
  },
}));

function Variation({ variation, prevValue, isPositiveVariation, children }) {
  // Hooks
  const classes = useStyles();
  const theme = Mui.useTheme();

  // Constants
  const numeric = Number(variation);
  const hasVariation = variation != null && variation !== '' && Number.isFinite(numeric);
  const isPositive = isPositiveVariation ?? numeric > 0;
  let color;
  if (numeric !== 0) {
    color = isPositive ? theme.palette.success.main : theme.palette.error.main;
  }

  return (
    <>
      {hasVariation && (
        <Mui.Typography component="div" className={classes.variation} style={{ color }}>
          <strong className={classes.value}>
            {numeric !== 0 && (
              <Mui.Icon fontSize="small">{isPositive ? 'north_east' : 'south_east'}</Mui.Icon>
            )}{' '}
            <PercentageField value={numeric} />
          </strong>
        </Mui.Typography>
      )}
      {!!prevValue && (
        <Mui.Typography variant="body2" color="textSecondary">
          {prevValue}
        </Mui.Typography>
      )}
      {children}
    </>
  );
}

Variation.propTypes = {
  variation: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  prevValue: PropTypes.any,
  isPositiveVariation: PropTypes.bool,
  children: PropTypes.node,
};

export default Variation;
